"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitrum = void 0;
exports.arbitrum = {
    "addresses": {
        "ProxyAdmin": "0xF04B152d2E27b5d975A2eb6b7F39EA42A74841Ac",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x898Db40f8e0C185274a7499A165B9AdA2cC2A5b6",
        "FeedPriceOracle": "0x6B8d67a775C5D999245516d0978DD4A31E920943",
        "CompLogic": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
        "RedemptionManager": "0x0855723CB0e37Ad7847e1268D0B0154e0905eEd7",
        "Timelock": "0xE649Fd017356D314e79649fBE5E20A9EC827D286",
        "Comptroller": "0xBfb69860C91A22A2287df1Ff3Cdf0476c5aab24A",
        "sdrETH": "0x3C752d0D78BbFddA6BF4b6000a01228B732441aE",
        "ETH": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x54e8B462804238e6a9386A5b1165E124ac061412",
        "suErc20": "0x731e7cC2205dD7c1ede982b05B85304363eefB01",
        "JumpRate#StableBC": "0x41d08FBa0B6C149710AD2002aE9909C75Ac7Cb1C",
        "JumpRate#BTCBC_AltStables": "0x986083F10EF5BAa4Eee4EFaf994befEb096D50c7",
        "JumpRate#wstETH": "0xc204081F30064713847e23a8B4b538565ee90bE9",
        "JumpRate#ETH": "0x642437CdfA252819460172F64c092bEf3fD41fD3",
        "ZeroRate": "0xd05152B962abB6C0d70b33CBe89037140B93a3af",
        "JumpRate#Others": "0xe06d2991a24ED17ed76a815CCf7a7C86acAAd5F2",
        "sdrUSDC": "0x4DE3741E1676ed14d661b1398196dC221cA4D37A",
        "USDC": "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        "sdrUSDT": "0xDb7Fe9c415281E383595c262e49568DDc18e8Bd4",
        "USDT": "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        "sdrDAI": "0x873449359d2d99691436E724C6C219a39b159B4a",
        "DAI": "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
        "sdrwstETH": "0x1167e762541374fEBeeA0f6Ed2AD4473AFa1CcEa",
        "wstETH": "0x5979D7b546E38E414F7E9822514be443A4800529",
        "sdrRETH": "0x1a9CFA6c676ebBEd450dB3cef03e399465F1202C",
        "RETH": "0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8",
        "sdrWBTC": "0x59aC82d3EfB5dc6c4389ccfF7AB7ab6C72C6AC05",
        "WBTC": "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        "sdrARB": "0x142017b52c99d3dFe55E49d79Df0bAF7F4478c0c",
        "ARB": "0x912CE59144191C1204E64559FE8253a0e49E6548",
        "sdrweETH": "0xd5BDa72030d9531fb311ddFE09aF5502C3492E0c",
        "weETH": "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
        "sdrrsETH": "0xEe67DB245248BDC84a6634e9A3e30FF78Eeb6179",
        "rsETH": "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
        "sdrsolvBTC": "0x32be989F762470473878456aB3fB8f6a5bb0205c",
        "solvBTC": "0x3647c54c4c2C65bC7a2D63c0Da2809B399DBBDC0",
        "sdrPT-weETH-26SEP2024": "0x7eCaC6929fdC7f98395857FC8B460f14C6898609",
        "PT-weETH-26SEP2024": "0xb8b0a120F6A68Dd06209619F62429fB1a8e92feC",
        "sdrPT-rsETH-26SEP2024": "0xaec7D67D07e1f5833a8587fDcb0b7FE50347a8F5",
        "PT-rsETH-26SEP2024": "0x30c98c0139B62290E26aC2a2158AC341Dcaf1333",
        "sdrPT-weETH-26DEC2024": "0x6C6E01110563305537d303e468B23A453BED2197",
        "PT-weETH-26DEC2024": "0xE2B2D203577c7cb3D043E89cCf90b5E24d19b66f",
        "sdrPT-rsETH-26DEC2024": "0x54525258ba4f089e72f062b0cc66774639B2e259",
        "PT-rsETH-26DEC2024": "0x355ec27c9d4530dE01A103FA27F884a2F3dA65ef",
        "sdrsuUSD": "0xe4B55045ed14815c7c42eeeF8EE431b89422c389",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuETH": "0x9C93423939C4e3D48d99baD147AD808BE89B2043",
        "suETH": "0x1c22531aa9747d76fff8f0a43b37954ca67d28e0",
        "sdrsuBTC": "0xAc6bAF36B28d19EA10959102158Beb3d933C1fbf",
        "suBTC": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x4DE3741E1676ed14d661b1398196dC221cA4D37A",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0xDb7Fe9c415281E383595c262e49568DDc18e8Bd4",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrDAI",
            "ctokenAddr": "0x873449359d2d99691436E724C6C219a39b159B4a",
            "underlySym": "DAI",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrwstETH",
            "ctokenAddr": "0x1167e762541374fEBeeA0f6Ed2AD4473AFa1CcEa",
            "underlySym": "wstETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x5979D7b546E38E414F7E9822514be443A4800529",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrRETH",
            "ctokenAddr": "0x1a9CFA6c676ebBEd450dB3cef03e399465F1202C",
            "underlySym": "RETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0x59aC82d3EfB5dc6c4389ccfF7AB7ab6C72C6AC05",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrARB",
            "ctokenAddr": "0x142017b52c99d3dFe55E49d79Df0bAF7F4478c0c",
            "underlySym": "ARB",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x912CE59144191C1204E64559FE8253a0e49E6548",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrweETH",
            "ctokenAddr": "0xd5BDa72030d9531fb311ddFE09aF5502C3492E0c",
            "underlySym": "weETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrrsETH",
            "ctokenAddr": "0xEe67DB245248BDC84a6634e9A3e30FF78Eeb6179",
            "underlySym": "rsETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsolvBTC",
            "ctokenAddr": "0x32be989F762470473878456aB3fB8f6a5bb0205c",
            "underlySym": "solvBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x3647c54c4c2C65bC7a2D63c0Da2809B399DBBDC0",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrPT-weETH-26SEP2024",
            "ctokenAddr": "0x7eCaC6929fdC7f98395857FC8B460f14C6898609",
            "underlySym": "PT-weETH-26SEP2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xb8b0a120F6A68Dd06209619F62429fB1a8e92feC",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-rsETH-26SEP2024",
            "ctokenAddr": "0xaec7D67D07e1f5833a8587fDcb0b7FE50347a8F5",
            "underlySym": "PT-rsETH-26SEP2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x30c98c0139B62290E26aC2a2158AC341Dcaf1333",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-weETH-26DEC2024",
            "ctokenAddr": "0x6C6E01110563305537d303e468B23A453BED2197",
            "underlySym": "PT-weETH-26DEC2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xE2B2D203577c7cb3D043E89cCf90b5E24d19b66f",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrPT-rsETH-26DEC2024",
            "ctokenAddr": "0x54525258ba4f089e72f062b0cc66774639B2e259",
            "underlySym": "PT-rsETH-26DEC2024",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x355ec27c9d4530dE01A103FA27F884a2F3dA65ef",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0xe4B55045ed14815c7c42eeeF8EE431b89422c389",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x9C93423939C4e3D48d99baD147AD808BE89B2043",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x1c22531aa9747d76fff8f0a43b37954ca67d28e0",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xAc6bAF36B28d19EA10959102158Beb3d933C1fbf",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x3C752d0D78BbFddA6BF4b6000a01228B732441aE",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x41d08FBa0B6C149710AD2002aE9909C75Ac7Cb1C",
            "tokens": [
                "USDC",
                "USDT",
                "DAI"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0933",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#BTCBC_AltStables",
            "contract": "JumpRateModelV2",
            "address": "0x986083F10EF5BAa4Eee4EFaf994befEb096D50c7",
            "tokens": [
                "RETH",
                "WBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0889",
            "jumpMultiplierPerYear": "5.5273",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0xe06d2991a24ED17ed76a815CCf7a7C86acAAd5F2",
            "tokens": [
                "ARB",
                "weETH",
                "rsETH",
                "solvBTC",
                "PT-weETH-26SEP2024",
                "PT-rsETH-26SEP2024",
                "PT-weETH-26DEC2024",
                "PT-rsETH-26DEC2024"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.1556",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0xd05152B962abB6C0d70b33CBe89037140B93a3af",
            "tokens": [
                "suUSD",
                "suETH",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=arbitrum.js.map